// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d0426ce8","732":"1c0c5915"}[chunkId] + ".chunk.js";
};